/* 布局 */
//前台
import Layout from "@views/layout";

const paruseraddressRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "paruseraddress/list",
        name: "PARUSERADDRESS",
        meta: {
            title: "家长收货地址",
        },
        component: () => import("@views/business/paruseraddress/index.vue"),
    },
        ],
};

export default paruseraddressRouter;
